module.exports = {
  SAVE_INTERCOMS: 'SAVE_INTERCOMS',
  APPEND_INTERCOMS: 'APPEND_INTERCOMS',
  SET_INTERCOMS_PAGINATION_DATA: 'SET_INTERCOMS_PAGINATION_DATA',
  RESET_INTERCOMS_PAGINATION_DATA: 'RESET_INTERCOMS_PAGINATION_DATA',
  SELECT_INTERCOM: 'SELECT_INTERCOM',
  RESET_INTERCOMS_FILTERS: 'RESET_INTERCOMS_FILTERS',
  SET_INTERCOM_FILTER: 'SET_INTERCOM_FILTER',
  UPDATE_INTERCOM: 'UPDATE_INTERCOM',
  SET_INTERCOM_OPERATIONAL_MODE: 'SET_INTERCOM_OPERATIONAL_MODE',
  SET_INTERCOM_ORDER: 'SET_INTERCOM_ORDER',
  SAVE_EXTENSIONS: 'SAVE_EXTENSIONS',
  APPEND_EXTENSIONS: 'APPEND_EXTENSIONS',
  SET_EXTENSIONS_PAGINATION_DATA: 'SET_EXTENSIONS_PAGINATION_DATA',
  RESET_EXTENSIONS_PAGINATION_DATA: 'RESET_EXTENSIONS_PAGINATION_DATA',
  SELECT_EXTENSION: 'SELECT_EXTENSION',
  UPDATE_EXTENSION: 'UPDATE_EXTENSION',
  SET_EXTENSION_OPERATIONAL_MODE: 'SET_EXTENSION_OPERATIONAL_MODE',
  RESET_EXTENSIONS_FILTERS: 'RESET_EXTENSIONS_FILTERS',
  SET_EXTENSION_FILTER: 'SET_EXTENSION_FILTER',
  SET_EXTENSION_ORDER: 'SET_EXTENSION_ORDER',
  SAVE_EXTENSION_GROUPS: 'SAVE_EXTENSION_GROUPS',
  APPEND_EXTENSION_GROUPS: 'APPEND_EXTENSION_GROUPS',
  SET_EXTENSION_GROUPS_PAGINATION_DATA: 'SET_EXTENSION_GROUPS_PAGINATION_DATA',
  RESET_EXTENSION_GROUPS_PAGINATION_DATA: 'RESET_EXTENSION_GROUPS_PAGINATION_DATA',
  UPDATE_EXTENSION_GROUP: 'UPDATE_EXTENSION_GROUP',
  SAVE_INTERCOM_EXTENSIONS: 'SAVE_INTERCOM_EXTENSIONS',
  APPEND_INTERCOM_EXTENSIONS: 'APPEND_INTERCOM_EXTENSIONS',
  SET_INTERCOM_EXTENSIONS_PAGINATION_DATA: 'SET_INTERCOM_EXTENSIONS_PAGINATION_DATA',
  RESET_INTERCOM_EXTENSIONS_PAGINATION_DATA: 'RESET_INTERCOM_EXTENSIONS_PAGINATION_DATA',
  SAVE_HYPER_TILES: 'SAVE_HYPER_TILES',
  APPEND_HYPER_TILES: 'APPEND_HYPER_TILES',
  SET_HYPER_TILES_PAGINATION_DATA: 'SET_HYPER_TILES_PAGINATION_DATA',
  RESET_HYPER_TILES_PAGINATION_DATA: 'RESET_HYPER_TILES_PAGINATION_DATA',
  SELECT_HYPER_TILE: 'SELECT_HYPER_TILE',
  UPDATE_HYPER_TILE: 'UPDATE_HYPER_TILE',
  SAVE_ALL_EXTENSIONS: 'SAVE_ALL_EXTENSIONS',
  FETCH_INTERCOM_LOCKS_BY_TAGS: 'FETCH_INTERCOM_LOCKS_BY_TAGS',
  CANCEL_FETCH_INTERCOM_LOCKS_BY_TAGS: 'CANCEL_FETCH_INTERCOM_LOCKS_BY_TAGS',
  SET_INTERCOM_LOCKS_FILTERED_BY_TAGS: 'SET_INTERCOM_LOCKS_FILTERED_BY_TAGS',
  APPEND_INTERCOM_LOCKS_FILTERED_BY_TAGS: 'APPEND_INTERCOM_LOCKS_FILTERED_BY_TAGS',
  SET_INTERCOM_LOCKS_FILTERED_BY_TAGS_PAGINATION_DATA: 'SET_INTERCOM_LOCKS_FILTERED_BY_TAGS_PAGINATION_DATA',
  FETCH_EXTENSION_USERS_BY_TAGS: 'FETCH_EXTENSION_USERS_BY_TAGS',
  CANCEL_FETCH_EXTENSION_USERS_BY_TAGS: 'CANCEL_FETCH_EXTENSION_USERS_BY_TAGS',
  SET_EXTENSION_USERS_FILTERED_BY_TAGS: 'SET_EXTENSION_USERS_FILTERED_BY_TAGS',
  APPEND_EXTENSION_USERS_FILTERED_BY_TAGS: 'APPEND_EXTENSION_USERS_FILTERED_BY_TAGS',
  SET_EXTENSION_USERS_FILTERED_BY_TAGS_PAGINATION_DATA: 'SET_EXTENSION_USERS_FILTERED_BY_TAGS_PAGINATION_DATA',
  SAVE_VIRTUAL_INTERCOM_LIMITS: 'SAVE_VIRTUAL_INTERCOM_LIMITS',
}; 